import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
interface BusPickupAllocationIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const SunIconDark: React.FC<BusPickupAllocationIconProps> = ({
  color,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.4C12.6628 2.4 13.2 2.93726 13.2 3.6V4.8C13.2 5.46274 12.6628 6 12 6C11.3373 6 10.8 5.46274 10.8 4.8V3.6C10.8 2.93726 11.3373 2.4 12 2.4Z"
      fill="#EEF7FF"
    />
    <path
      d="M16.8 12C16.8 14.651 14.651 16.8 12 16.8C9.34906 16.8 7.20002 14.651 7.20002 12C7.20002 9.34904 9.34906 7.2 12 7.2C14.651 7.2 16.8 9.34904 16.8 12Z"
      fill="#EEF7FF"
    />
    <path
      d="M16.2427 17.9397L17.0913 18.7882C17.5599 19.2568 18.3197 19.2568 18.7883 18.7882C19.2569 18.3196 19.2569 17.5598 18.7883 17.0911L17.9398 16.2426C17.4712 15.774 16.7114 15.774 16.2427 16.2426C15.7741 16.7112 15.7741 17.471 16.2427 17.9397Z"
      fill="#EEF7FF"
    />
    <path
      d="M18.7882 5.21171C19.2568 5.68034 19.2568 6.44014 18.7882 6.90877L17.9397 7.7573C17.471 8.22593 16.7112 8.22593 16.2426 7.7573C15.774 7.28867 15.774 6.52887 16.2426 6.06024L17.0911 5.21171C17.5598 4.74308 18.3196 4.74308 18.7882 5.21171Z"
      fill="#EEF7FF"
    />
    <path
      d="M20.4 13.2C21.0628 13.2 21.6 12.6627 21.6 12C21.6 11.3373 21.0628 10.8 20.4 10.8H19.2C18.5373 10.8 18 11.3373 18 12C18 12.6627 18.5373 13.2 19.2 13.2H20.4Z"
      fill="#EEF7FF"
    />
    <path
      d="M12 18C12.6628 18 13.2 18.5373 13.2 19.2V20.4C13.2 21.0627 12.6628 21.6 12 21.6C11.3373 21.6 10.8 21.0627 10.8 20.4V19.2C10.8 18.5373 11.3373 18 12 18Z"
      fill="#EEF7FF"
    />
    <path
      d="M6.0604 7.75732C6.52903 8.22595 7.28882 8.22595 7.75745 7.75732C8.22608 7.28869 8.22608 6.52889 7.75745 6.06026L6.90893 5.21173C6.4403 4.74311 5.6805 4.74311 5.21187 5.21173C4.74324 5.68036 4.74324 6.44016 5.21187 6.90879L6.0604 7.75732Z"
      fill="#EEF7FF"
    />
    <path
      d="M7.75734 17.9396L6.90881 18.7882C6.44018 19.2568 5.68039 19.2568 5.21176 18.7882C4.74313 18.3195 4.74313 17.5597 5.21176 17.0911L6.06029 16.2426C6.52891 15.7739 7.28871 15.7739 7.75734 16.2426C8.22597 16.7112 8.22597 17.471 7.75734 17.9396Z"
      fill="#EEF7FF"
    />
    <path
      d="M4.80002 13.2C5.46277 13.2 6.00002 12.6627 6.00002 12C6.00002 11.3373 5.46277 10.8 4.80002 10.8H3.60002C2.93728 10.8 2.40002 11.3373 2.40002 12C2.40002 12.6627 2.93728 13.2 3.60002 13.2H4.80002Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default SunIconDark;
